import React, { useState, useEffect } from 'react';
import DonationsData from '../../Datas/DonationsData';
import DonationDetailsModal from './DonationDetailsModal';
import DonationRequestFormModal from './DonationRequestFormModal';
import './DonationRequests.css';

const DonationRequests = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedDonation, setSelectedDonation] = useState(null);
  const [showRequestForm, setShowRequestForm] = useState(false);
  const [showDonationModal, setShowDonationModal] = useState(false);
  const [selectedDonationId, setSelectedDonationId] = useState(null);
  const [eta, setEta] = useState(null);  // Store the ETA
  const [location, setLocation] = useState(null);  // Store the location

  // Filter donations based on the search term
  const filteredDonations = DonationsData.filter(donation =>
    donation.hospital_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    donation.medicine.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    if (selectedDonationId !== null) {
      // Mocking location and ETA fetching
      const donation = DonationsData.find(d => d.donation_id === selectedDonationId);
      if (donation) {
        setLocation(donation.location);  // Get location from the selected donation
        // Mocking ETA calculation (You can replace this with an actual API call)
        setEta('1 hour 20 minutes');  // Replace with actual logic for ETA
      }
    }
  }, [selectedDonationId]);

  const handleMoreDetails = (donation) => {
    setSelectedDonation(donation);
  };

  const handleDonateNow = (donationId) => {
    console.log('Donate Now for donation ID:', donationId);
    setSelectedDonationId(donationId);
    setShowDonationModal(true);  // Show the modal with location and ETA
  };

  const handleRequestMedicine = () => {
    setShowRequestForm(true);
  };

  const handleCloseRequestForm = () => {
    setShowRequestForm(false);
  };

  const handleCancelDonation = () => {
    setShowDonationModal(false);  // Close the modal if cancel is clicked
  };

  const handleConfirmDonation = () => {
    console.log('Donation confirmed');
    setShowDonationModal(false);  // Close the modal after confirming
  };

  return (
    <div className="donation-request-container">
      <div className="search-bar-donation">
        <input
          type="text"
          placeholder="Search for hospitals or medicines..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="request-medicine-btn">
        <button onClick={handleRequestMedicine}>Request Medicine</button>
      </div>

      <div className="donation-cards">
        {filteredDonations.map(donation => (
          <div className="donation-card" key={donation.donation_id}>
            <div className="card-header">
              <h3>{donation.hospital_name}</h3>
              <span className="status">{donation.status}</span>
            </div>
            <p><strong>Medicine:</strong> {donation.medicine}</p>
            <p><strong>Quantity Needed:</strong> {donation.quantity_needed}</p>
            <p><strong>Location:</strong> {donation.location}</p>
            <p><strong>Created At:</strong> {new Date(donation.created_at).toLocaleDateString()}</p>
            
            <div className="card-buttons">
              <button onClick={() => handleMoreDetails(donation)}>More Details</button>
              <button onClick={() => handleDonateNow(donation.donation_id)}>Donate Now</button>
            </div>
          </div>
        ))}
      </div>

      {selectedDonation && <DonationDetailsModal donation={selectedDonation} onClose={() => setSelectedDonation(null)} />}
      {showRequestForm && <DonationRequestFormModal onClose={handleCloseRequestForm} />}

      {showDonationModal && (
        <div className="donation-modal">
          <h3>Confirm Donation</h3>
          <p><strong>Hospital Location:</strong> {location}</p>
          <p><strong>Estimated Delivery Time (ETA):</strong> {eta}</p>

          <div className="modal-buttons">
            <button onClick={handleConfirmDonation}>Confirm Donation</button>
            <button onClick={handleCancelDonation}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DonationRequests;
